/**
 * Somebody stuck somewhere, and something between them and getting back.
 *
 * A beat posts one (`chapters.js`, `posts`). What it does when it is posted is
 * the whole of what is authored: the guest whose row says `strands` stays where
 * they are, too frightened to move, and one animal is put out near them. Nothing
 * after that is written. The animal does what its row says, the guest gets in
 * the golf cart the way anybody offered a lift does, and whether they get back
 * is whether you got them back.
 *
 *   stranded   where the guest is, in feet
 *   animal     which wildlife row is put out, and where, in feet
 *   works      zones the job puts you in (`access.js`), like a strike
 *   safe       rooms where letting them out counts as back
 *   lasts      game minutes before the guest gives up on anybody coming and
 *              makes their own way back, which is what abandoning them is
 *   award      standing when they are got back safe, like any award
 *   hurt       standing when the animal got to them first
 *   left       standing when nobody came
 *
 * A hurt guest and an abandoned one also complain, through the same path a
 * guest's complaint about you always goes through.
 */
export const RESCUES = [
  {
    id: 'lion-rescue',
    title: 'A guest out past the courts',
    // Out on the course west of the courts, at the far end of the cart road.
    stranded: [-422, 14],
    // Thirty feet off, which is just further than it notices a person from.
    animal: { id: 'mountainlion', at: [-428, 44] },
    works: ['caytons-zone'],
    safe: ['parking', 'apron'],
    // An hour and a half. The cart road is half a minute each way, half an
    // hour of the clock, and the last of it is round the courts at a crawl so
    // the cart makes no noise, which is most of another hour: the forty-five
    // minutes this was when the courts were over the lot fence is nobody
    // getting there in time who does it properly.
    lasts: 90,
    award: { valet: 14 },
    hurt: { valet: -10 },
    left: { valet: -6 },
  },
];

export const RESCUES_BY_ID = Object.freeze(Object.fromEntries(RESCUES.map((row) => [row.id, row])));

export default RESCUES;
